import { Table } from 'antd'
import styled from 'styled-components'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'

export const StyledTable = styled(Table)`
  padding: ${props => (props.padding ? props.padding : '0px')};
  width: ${props => (props.width ? props.width : '')};
  .ant-table-thead {
    height: 60px;
  }
  td.last-ant-table-current-round {
    border-right: 3px solid rgba(50, 73, 215, 1) !important;
    border-left: 3px solid rgba(50, 73, 215, 1) !important;
  }

  th.last-ant-table-current-round {
    background-color: rgba(50, 73, 215, 1) !important;
    color: white;
  }
  .last-tr-class td.last-ant-table-current-round {
    border-bottom: 3px solid rgba(50, 73, 215, 1) !important;
  }

  tr:last-child td.last-ant-table-current-round {
    border-bottom: 3px solid rgba(50, 73, 215, 1) !important;
  }

  .ant-table-cell {
    border: 1px solid rgba(127, 127, 127, 0.25);
    padding: 8px;
  }

  border-top-left-radius: 0;
  border-top-right-radius: 0;

  border-top-radius: 0;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  .ant-table-tbody > tr:hover > td {
    background-color: ${props => (props.hover ? '#ffffff' : '#fafafa')};
  }

  .ant-table-tbody > tr > td {
    background-color: ${props => (props.headerColor ? '#FAFAFB' : '#ffffff')};
  }

  .ant-table-thead
    > tr
    > th:not(:last-child):not(.ant-table-selection-column):not(
      .ant-table-row-expand-icon-cell
    ):not([colspan])::before {
    content: none;
  }
  .ant-table-container table > thead > tr:first-child th:first-child,
  .ant-table-container table > tbody > tr td:first-child {
    padding-left: ${props => (props.paddingLeft ? '0px' : '25px')};
  }
  .ant-table-container table > thead > tr:first-child th:last-child,
  .ant-table-container table > tbody > tr td:last-child {
    padding-right: 25px;
  }
  tr {
    th {
      background: ${props =>
        props.headerColor ? 'white' : COLORS.PRIMARY_GREY_T_98};
      font-style: normal;

      font-weight: ${props => (props.fontWeight ? '600' : FONT.FW_500)};

      font-size: ${props => (props.fontSize ? '15px' : FONT.F_XS)};
      line-height: 1.125em;
      letter-spacing: 0.1em;
      text-transform: uppercase;
      color: ${COLORS.GREY_T_30};

      ::before {
        height: 0px;
      }
    }
  }
  .ant-table-pagination.ant-pagination {
    justify-content: center;
  }
  .ant-radio-inner {
    background-color: transparent;
  }

  .ant-table-expanded-row td {
    padding: ${props =>
      props?.expandedRowPadding ? props?.expandedRowPadding : '0'} !important;
  }

  .ant-table th.ant-table-column-has-sorters.ant-table-column-sort:hover {
    border-bottom: 2px solid transparent !important;
  }
`
